// extracted by mini-css-extract-plugin
export var aboveInput = "_mz-0";
export var actionButton = "_mz-5";
export var actionButtonContainer = "_mz-1";
export var actionIcon = "_mz-6";
export var aiInfoContainer = "_mz-2";
export var attachmentWrapper = "_mz-7";
export var bold = "_mz-3";
export var checkIcon = "_mz-8";
export var clickingRecipientBar = "_mz-11";
export var commentThreadSwitch = "_mz-a";
export var draftImage = "_mz-b";
export var draftImageContainer = "_mz-c";
export var draftImages = "_mz-e";
export var editButton = "_mz-g";
export var editor = "_mz-f";
export var editorContainer = "_mz-y";
export var editorErrorTooltipWrapper = "_mz-9";
export var headerDivider = "_mz-h";
export var icon = "_mz-i";
export var info = "_mz-j";
export var internal = "_mz-n";
export var internalDivider = "_mz-k";
export var internalMessage = "_mz-l";
export var messageInputCard = "_mz-m";
export var messageInputForm = "_mz-o";
export var messageInputFormInternal = "_mz-p";
export var options = "_mz-q";
export var publicMessageCustomer = "_mz-s";
export var publicMessageMerchant = "_mz-r";
export var removeImageButton = "_mz-d";
export var replyButtons = "_mz-t";
export var showSignatureButton = "_mz-u";
export var spinner = "_mz-v";
export var verticalButtonDivider = "_mz-4";
export var visibilitySelector = "_mz-w";
export var warning = "_mz-x";
export var wrappingText = "_mz-z";
export var writingInternalNoteTopBorder = "_mz-10";